export default __webpack_public_path__ + "static/media/laptop-tech-specs.b3d8440b.png";